import api from './../api';
import timeDifference from './../utils/my_module';

export const fetchDevices = ({commit, state}, data) => {
    if (!data) data = {mode: 'box', searchValue: ''};
    return api.fetchDevices(data.mode)
        .then(async (devices) => {
            if (!devices.success) return devices;
            if (data.mode === 'bridge') {
                devices.data = devices.data.map((device, i) => {
                    let lastSeen = new Date(device.lastSeen);
                    let now = new Date();
                    let online = now.getTime() - lastSeen.getTime() < 1000 * 30

                    let created_at = new Date(parseInt(device._id.substring(0, 8), 16) * 1000);

                    return {
                        id: i,
                        device_name: 'Bridge',
                        status: online ? 'Online' : 'Offline',
                        uuid: device.macAddress,
                        os_version: "-",
                        os_variant: "-",
                        supervisor_version: "-",
                        ip_address: device.localIp,
                        release: device.softwareBranch && device.softwareVersion ? `${device.softwareBranch}/${device.softwareVersion}` : 'Latest',
                        device_type: "Weinzierl",
                        last_seen: device.lastSeen,
                        appId: -1,
                        created_at: created_at.toISOString(),
                        server: device.server
                    }
                });
            }

            // console.log('DEVICES: ', devices, data.mode)

            if (devices.success == true) {
                let devicesByApps = {
                    'all': []
                };

                if (data.searchValue != '') {
                    let devicesArr = data.searchValue.split(',')
                    let allDevices = JSON.parse(JSON.stringify(devices.data));
                    let filteredDevices = [];
                    devicesArr.forEach(uuid => {
                        uuid = uuid.trim();
                        filteredDevices = filteredDevices.concat(allDevices.filter(device => device.uuid.includes(uuid) || (device.ip_address && device.ip_address.includes(uuid))));
                        
                        allDevices = allDevices.filter(device => !device.uuid.includes(uuid))
                    })
                    if (filteredDevices.length == 0) {
                      try {
                        let cloudDevices = await api.fetchDevices('box-cloud')
                        if (cloudDevices.success == true) {
                          let filteredCloudDevices = cloudDevices.data.filter(d=>d.ip.includes(data.searchValue))
                          filteredDevices = filteredDevices.concat(allDevices.filter(device => filteredCloudDevices.find(a=>a.macAddress.replace('1HomeBox_','') == device.uuid)));
                        }
                      } catch (e) {
                        console.log(e)
                      }
                    }
                    devices.data = filteredDevices;
                }
                devices.data.forEach(async device => {

                    // Check tracking information for each device

                    // let tracking = await api.lockOverride(device.uuid, 'STATUS');
                    // if (tracking.message === true || tracking.message === false) {
                    //     device.tracking = tracking.message;
                    // }
                    
                    if (!devicesByApps[device.appId]) {
                        devicesByApps[device.appId] = [];
                    }
                    devicesByApps[device.appId].push(device);
                    devicesByApps.all.push(device);
                });
                commit('setDevices', devicesByApps);
            }
            else {
                throw new Error(devices.data[0].message)
            }
        }).catch((err) => {
            throw new Error('fetchDevices err: ' + err.message)
        });
}

export const fetchApps = ({commit, state}, uuid) => {
    return api.fetchApps().then((apps) => {
    	if (apps.success == true) {
	        commit('setApps', apps.data);
	    }
	    else {
	    	throw new Error(`Fetch Apps Error: ${apps.data[0].message}`);
	    }
    }).catch((err) => {
    	throw new Error('fetchApps err: ' + err.message)
    });
}

export const fetchLogsElastic = ({commit,state}, uuid) => {
	return api.fetchLogs(uuid)
        .then((logs) => {

            let newLogs = logs.hits.hits.map(log => {
                if (!uuid.includes('knxBridge') && !uuid.includes('1HomeBox') && !uuid.includes(':')) {
                    log._source.dateTime = log._source['@timestamp'];
                    delete log._source['@timestamp'];
                } else {
                  if (log._source.json && log._source.json.level) {
                    log._source.severity = log._source.json.level

                  } else {
                    log._source.severity = log._source.type

                  }
                }          
                delete log._source.fields;
                if (!log._source.message && log._source.json) log._source.message = log._source.json.message;
                if (log._source.json && log._source.json.error) {
                  log._source.message += ' - ' + log._source.json.error
                }
                return log._source;
            })

            commit('setLogs', {elastic: newLogs.reverse()});
        })
        .catch((err) => {
            throw new Error('fetchLogs err: ' + err.message)
        });
}

export const fetchLogsBalena = ({commit,state}, uuid) => {
    return api.balenaLogs(uuid)
        .then(response => {
            let deviceLogs = [];

            if (typeof response.data === 'string') {
                return;
            }

            response.data.forEach(log => {
                try {
                    let msg = JSON.parse(log.message);
                } catch(e) {
                    deviceLogs.push(log);
                }
            });

            commit('setLogs', {device: deviceLogs});
        })
}

export const clearLogs = ({commit,state}, uuid) => {
    commit('setLogs', {});
}

export const updateAll = ({commit, state}, data) => {
    return api.updateAll(data);
}

export const deviceFromCloud = ({commit, state}, data) => {
    return api.deviceFromCloud(data);
}

export const deviceStoreFlags = ({commit, state}, data) => {
    return api.deviceStoreFlags(data);
}

export const setDeviceStoreFlags = ({commit, state}, data) => {
    return api.setDeviceStoreFlags(data);
}

export const deviceLogLevel = ({commit, state}, data) => {
    return api.deviceLogLevel(data);
}

export const setDeviceLogLevel = ({commit, state}, data) => {
    return api.setDeviceLogLevel(data);
}

export const createKibanaLink = ({commit, state}, id) => {
	return "http://localhost:5601/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fy,to:now%2Fy))&_a=(columns:!(_source),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:logs_index,key:fields.deviceID,negate:!f,params:(query:'"+id+"'),type:phrase,value:'"+id+"'),query:(match:(fields.deviceID:(query:'"+id+"',type:phrase))))),index:logs_index,interval:auto,query:(language:kuery,query:''),sort:!('@timestamp',desc))"
}

export const setTerminalOutput = ({commit, state}, output) => {
	let out = output.split("[*!:]");
	let command = out[0]
	output = out[1]
	let directory = ""
	if (out[2]=="error") { directory = "ERROR" }
	else directory = out[2]
	commit('setTerminalOutput', {"command": command, "output": output, "directory": directory});
}



// WEBPACK FOOTER //
// ./src/store/actions.js